/**
 * Created by r4zi4l on 24.06.2021
 */

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    DARK_TEXT_COLOR: new cc.Color(137, 64, 45, 255),
    GREEN: new cc.Color(111, 192, 38, 255),
    COLOR_RED: new cc.Color(243, 73, 64, 255),
    COLOR_BONUS: new cc.Color(159, 91, 244, 255),
    SHOP_STROKE_COLOR: new cc.Color(0, 0, 0, 100),
    SHOP_SHADOW_COLOR: new cc.Color(0, 0, 0, 80),
    TILE_REWARDS_COLOR: new cc.Color(9, 89, 151, 255),
    YELLOW_TEXT_COLOR: new cc.Color(247, 230, 43, 255),
    LIGHT_TEXT_DISABLED_COLOR: new cc.Color(200, 200, 200, 255),
    DARK_BLUE_TEXT_COLOR: new cc.Color(28, 69, 110, 255),
    ORANGE_BROWN_TEXT_COLOR: new cc.Color(159, 74, 29, 255),
    STICKERS_COLLECTION_COLOR: new cc.Color(160, 87, 96, 255),
    STICKER_LABEL_COLOR: new cc.Color(205, 126, 99, 255),
    MENUBAR_TIMER_COLOR: new cc.Color(33, 193, 255, 255),
    LIGHT_BROWN_COLOR_1: new cc.Color(184, 110, 80, 255),
    LIGHT_BROWN_COLOR_2: new cc.Color(221, 153, 107, 255)
});

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    SHOP_STROKE: {
        color: cleverapps.styles.COLORS.SHOP_STROKE_COLOR,
        size: 1
    },

    SHOP_SHADOW: {
        color: cleverapps.styles.COLORS.SHOP_SHADOW_COLOR,
        direction: cc.size(0, -2),
        blur: 3
    },

    TITLE_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.TITLE_SHADOW,
        direction: cc.size(0, -2),
        blur: 1
    },

    LIGHT_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE_COLOR,
        size: 1
    },

    LIGHT_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_SHADOW_COLOR,
        direction: cc.size(0, -3),
        blur: 3
    },

    GAME_MESSAGE_STROKE: {
        color: new cc.Color(102, 62, 30, 255),
        size: 2
    },

    GAME_MESSAGE_SHADOW: {
        color: new cc.Color(65, 26, 9, 210),
        direction: cc.size(0, -3),
        blur: 2
    },

    LEADERS_STROKE: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        size: 2
    },

    LEADERS_SHADOW: {
        color: new cc.Color(0, 0, 0, 128),
        direction: cc.size(0, -4),
        blur: 5
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MENUBAR_TEXT: {
        name: "nostroke",
        size: 52,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    MENUBAR_TEXT_DELTA: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    MENUBAR_TIMER_TEXT: {
        name: "nostroke",
        size: 48,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    MENUBAR_LEVEL_WITH_AVATAR_TEXT: {
        size: 33
    },

    MENUBAR_PREMIUM_STICKER_TEXT: {
        size: 24,
        color: new cc.Color(192, 83, 0, 255),
        stroke: undefined
    },

    SIDEBAR_ICON_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    EXTRABAR_ICON_TEXT: {
        name: "nostroke",
        size: 26,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },
    
    MENUBAR_LEVEL_TEXT: {
        size: 66
    },

    LEVELUPWINDOW_TITLE_TEXT: {
        size: 96,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    LEVELUPWINDOW_VALUE_TEXT: {
        size: 200,
        color: cc.hexToColor("a46947"),
        stroke: undefined
    },

    LEVELUPWINDOW_REWARD_TEXT: {
        name: "big_digits",
        size: 55,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    MENUBAR_PROGRESS_TEXT: {
        size: 34,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    },

    TILE_SHOP_OFFER_TEXT: {
        name: "default",
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        size: 45
    },

    TILE_SHOP_COINS_OFFER: {
        name: "default",
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        size: 60
    },

    SHOP_WINDOW_SMALL_TILE_TITLE: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        shadow: cleverapps.styles.DECORATORS.SHOP_SHADOW
    },

    SHOP_LIVES_PRODUCT_TILE_DESCRIPTION_TEXT: {
        name: "nostroke",
        size: 32,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    TILE_REWARDS: {
        size: 40,
        name: "nostroke",
        color: cleverapps.styles.COLORS.TILE_REWARDS_COLOR
    },

    TILE_REWARDS_HEADER: {
        size: 30,
        name: "nostroke",
        color: cleverapps.styles.COLORS.TILE_REWARDS_COLOR
    },

    SHOP_WINDOW_TILE_TITLE: {
        name: "default",
        size: 55,
        color: cleverapps.styles.COLORS.WHITE
    },

    PRODUCT_TILE_LIMIT_TEXT: {
        name: "nostroke",
        size: 26,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PACKWINDOW_TEXT: {
        name: "default",
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    SHOP_WINDOW_LIVES_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        size: 40
    },

    TILE_SHOP_BADGE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TILE_SHOP_BADGE_STROKE
    },

    TIMER_TEXT: {
        name: "nostroke",
        size: 40,
        stroke: undefined,
        shadow: undefined,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    EXPEDITION_WINDOW_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    CHAT_REWARD_COUNT_TEXT: {
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    RATE_WINDOW_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PACK_TILE_REWARDS_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    WINDOW_TITLE_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    NOBG_WINDOW_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },
    WINDOW_SMALL_TEXT: {
        name: "nostroke",
        size: 34,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    TOURNAMENT_PLAYER_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.WHITE
    },
    WINDOW_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    EXTRA_WINDOW_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    LOADING_ANIMATION_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    FBCONNECT_WINDOW_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    TERMS_WINDOW_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LIGHT_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    LIGHT_TITLE_TEXT_DISABLED: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_DISABLED_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    UNIT_PROB: {
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    FORCE_MESSAGE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.ORANGE_BROWN_TEXT_COLOR
    },

    DIALOGUE_MESSAGE_TEXT: {
        size: 55,
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR
    },

    LIGHT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    DARK_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LOADING_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    REWARDS_LIST_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    },

    REWARD_WINDOW_REWARDS_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    FRIEND_REQUEST_TEXT: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    CLANS_ROW_NAME_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    CLAN_CHAT_PHRASE: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    CLAN_CHANGE_EMBLEM_TEXT: {
        size: 46,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    SUBSCRIPTION_BUTTON_TITLE: {
        size: 22,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_DISABLED_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    SUBSCRIPTION_MAIN_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TERMS_LINK_TEXT: {
        size: 26,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TERMS_TEXT: {
        size: 22,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_DISABLED_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    VIPREWARDEDWINDOW_DESCRIPTION_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    VIPREWARDEDWINDOW_TIMER_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    VIPREWARDEDWINDOW_NOTE_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PROLONG_BUTTON_AMOUNT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE
    },

    DIALOGUE_PERSON_TITLE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SHOP_USER_GOLD_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.ORANGE_BROWN_TEXT_COLOR
    },

    GAME_MESSAGE_TEXT: {
        size: 86,
        color: new cc.Color(130, 70, 40, 255)
    },

    NOADS_BONUS_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        size: 60
    },

    RACE_WINDOW_MAIN_TITLE_TEXT: {
        size: 78,
        color: new cc.Color(255, 201, 39, 255),
        stroke: undefined,
        shadow: cleverapps.styles.DECORATORS.MISSION_SHADOW
    },
    UNITSSHOP_BOTTOM_TIMER: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    UNITSSHOP_CART_AMOUNT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    TOOLTIP_TEXT: {
        size: 30,
        color: new cc.Color(161, 80, 37, 255),
        stroke: undefined
    },
    TOOLTIP_REWARDS_FONT: {
        name: "nostroke",
        size: 30,
        color: new cc.Color(161, 80, 37, 255),
        stroke: undefined
    },

    UNITFAMILY_TITLE: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX,
        shadow: undefined
    },

    HERODETAILS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    BONUS_WORKER_WINDOW_TIMER_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PROFILE_WINDOW_NICKNAME_GENERATOR_NICKNAME_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    MENUBAR_TOOLTIP_TEXT: {
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    MENUBAR_TOOLTIP_NUMBERS_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LEADERS_MAIN_TITLE_TEXT: {
        size: 90,
        color: new cc.Color(255, 234, 0, 255),
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    LEADERS_TIMER_TEXT: {
        name: "nostroke",
        size: 42,
        color: new cc.Color(137, 64, 44, 255),
        stroke: undefined,
        shadow: undefined
    },

    BUTTON_BOOSTER: {
        size: 34,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    bg: {
        width: 265,
        height: 83,
        timerHeight: 122,
        minWidth: 247,
        padding: {
            right: 16,
            top: 0,
            bottom: 2
        }
    },

    items: {
        GoldItem: {
            icon: {
                scale: 1.11
            }
        },

        CoinsItem: {
            icon: {
                scale: 1.11
            }
        },

        LivesItem: {
            bg: {
                width: 291
            },

            icon: {
                scale: 1.03
            }
        },

        WandsItem: {
            icon: {
                scale: 1.14
            }
        },

        WorkersItem: {
            bg: {
                width: 291
            },

            icon: {
                scale: 1.23
            }
        }
    },

    icon: {
        x: 15,
        y: 3
    },

    plusButton: {
        scale: 1.14,
        offset: {
            x: -15,
            y: 2
        }
    },

    iconText: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 9 }
        }
    },

    attention: {
        x: { align: "right", dx: 7 },
        y: { align: "bottom", dy: -13 }
    },

    timer: {
        x: { align: "center", dx: 23 },
        y: { align: "bottom", dy: 8 }
    },

    premiumSticker: {
        y: { align: "center", dy: 48 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarTextView, {
    amountText: {
        dy: 8
    }
});

if (cleverapps.styles.AvatarMenuBarView) {
    cleverapps.overrideStyles(cleverapps.styles.AvatarMenuBarView, {
        height: 91,

        level: {
            x: { align: "left", dx: -20 },
            y: { align: "bottom", dy: -17 },
            scale: [1.25, 1, 1],
            text: {
                x: { align: "center", dx: -1 },
                y: { align: "center", dy: -5 }
            },

            collections: {
                x: { align: "left", dx: -15 },
                y: { align: "bottom", dy: -36 },
                text: {
                    x: { align: "center", dx: -1 },
                    y: { align: "center", dy: 5 }
                }
            }
        },

        avatar: {
            x: { align: "center" },
            y: { align: "top" },

            size: {
                width: 185,
                height: 195
            },

            mobileSize: [{
                width: 163,
                height: 173
            }, {
                width: 185,
                height: 195
            }, {
                width: 185,
                height: 195
            }],

            padding: 0
        },

        progress: {
            x: { align: "center", dx: 20 },
            y: { align: "bottom", dy: -2 },

            width: 130,
            mobileWidth: [117, 130, 130]
        },

        toolTipContent: {
            margin: 20
        }
    });
}

if (cleverapps.styles.QuestsTableView) {
    cleverapps.overrideStyles(cleverapps.styles.QuestsTableView, {
        size: {
            width: 210,
            height: 580
        }
    });
}

if (cleverapps.styles.LevelUpWindow) {
    cleverapps.overrideStyles(cleverapps.styles.LevelUpWindow["default"], {
        alignTop: true,
        animation: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 130 }
        },

        title: {
            x: { align: "center", dx: 5 },
            y: { align: "center", dy: 320 },
            width: 600,
            height: 0,

            delay: 0.4333,
            duration: 0.2
        },

        value: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -50 },

            delay: 0.6667,
            duration: 0.2
        },

        rewards: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -90 },

            delay: 1,
            duration: 0.2,
            margin: 20,
            options: {
                textDirection: cleverapps.UI.VERTICAL,
                noPrefix: false,
                shine: true,
                margin: { x: 80, y: 60 },
                font: {
                    name: "big_digits",
                    size: 50,
                    color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
                    stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
                    shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
                }
            }
        }
    });
}

if (cleverapps.styles.ProgressView) {
    cleverapps.overrideStyles(cleverapps.styles.ProgressView, {
        icon: {
            offset: {
                y: 6,
                x: 52
            },
            bg: {
                padding: {
                    x: 11,
                    y: 10
                },
                x: { align: "center" },
                y: { align: "center", dy: 1 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.CloseButton, {
    scale: [0.8, 1, 1],
    position: [{
        x: { align: "right", dx: 12 },
        y: { align: "top", dy: 15 }
    }, {
        x: { align: "right", dx: 20 },
        y: { align: "top", dy: 20 }
    }, {
        x: { align: "right", dx: 20 },
        y: { align: "top", dy: 20 }
    }]
});

cleverapps.overrideStyles(cleverapps.styles.Window, {
    border: {
        x: 25,
        top: 30,
        bottom: 30
    },

    padding: {
        x: 60,
        top: 70,
        bottom: 40
    },

    decors: {
        "decor_title_right": true,
        "decor_title_left": true,
        "window_notch_top": true,
        "window_notch_bottom": true,
        "window_notch_left": true,
        "window_notch_right": true,
        "window_liana_top_left": true,
        "window_liana_top_right": true,
        "window_liana_left": true,
        "window_liana_right": true,
        "window_liana_bottom_left": true,
        "window_liana_bottom_right": true
    },

    Background: {
        padding: {
            x: -3,
            y: 40
        }
    },

    HelpButton: {
        x: { align: "left", dx: 35 },
        y: { align: "top", dy: -45 },
        lovesTitle: true
    },

    windowShowUpAnimation: {
        name: "defaultTropic"
    }
});

cleverapps.overrideStyles(cleverapps.styles.TileBadge, {
    width: 115,
    x: { align: "center", dx: 2 },
    y: { align: "center", dy: 7 },
    text: {
        rotation: 12
    },
    rotation: 0
});

cleverapps.overrideStyles(cleverapps.styles.UI, {
    Avatar: {
        x: 10,
        top: 10,
        bottom: 10
    }
});

cleverapps.overrideStyles(cleverapps.styles.Timer, {
    width: 230,
    
    timer: {
        x: { align: "center", dx: 16 },
        y: { align: "center", dy: 5 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PrizeBarComponent, {
    mark: {
        x: { align: "right", dx: 45 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.Tabs, {
    buttons: {
        width: 135,
        height: 240
    },

    attention: {
        x: { align: "left", dx: -20 },
        y: { align: "top", dy: -15 }
    },

    margin: 6
});

cleverapps.overrideStyles(cleverapps.styles.SubscriptionButtons, {
    buttonWidth: 410,
    buttonHeight: 120
});

if (cleverapps.styles.CookieJarView) {
    cleverapps.overrideStyles(cleverapps.styles.CookieJarView, {
        scale: 0.6,
        prizeFlyPositionShift: {
            y: 40,
            x: -50
        }
    });
}

if (cleverapps.styles.LandmarkSelectItem) {
    cleverapps.overrideStyles(cleverapps.styles.LandmarkSelectItem, {
        title: {
            y: {
                align: "center",
                dy: 95
            },

            width: 200
        },

        unit: {
            x: { align: "center" },
            y: {
                align: "center",
                dy: -15
            },

            width: 160,
            height: 160
        },

        minimal_dialogue: {
            scale: 0.6
        },

        unit_background: {
            width: 250,
            height: 260
        },

        checkmark: {
            x: {
                align: "right",
                dx: -15
            },
            y: {
                align: "bottom",
                dy: -10
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RowView, {
    width: 1130,
    height: 135,

    paddingX: 40,

    content: {
        y: { align: "center", dy: 2 },
        height: 104
    },

    place: {
        withBadge: {
            width: 80
        },

        width: 50
    },

    name: {
        x: { align: "left" }
    },

    prize: {
        width: 110,
        verticalWidth: 110
    },

    score: {
        content: {
            x: { align: "center" },
            y: { align: "center", dy: -2 }
        },
        width: 160,
        verticalWidth: 140,
        height: 74
    }
});

cleverapps.overrideStyles(cleverapps.styles.DefaultTableStyles, {
    margin: -6
});

if (cleverapps.styles.DailyCupView) {
    cleverapps.overrideStyles(cleverapps.styles.DailyCupView, {
        title: {
            width: 700,
            height: 122,

            text: {
                width: 500,

                y: { align: "center", dy: -20 }

            }
        }
    });
}

if (cleverapps.styles.BackgroundsWindow) {
    cleverapps.overrideStyles(cleverapps.styles.BackgroundsWindow, {
        lockWithName: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        name: {
            x: { align: "center" },
            y: { align: "center" },

            bg: {
                x: { align: "center" },
                y: { align: "top", dy: -10 }
            }
        },

        padding: {
            top: -40,
            bottom: -24,
            right: -30,
            left: -30
        },

        item: {
            bg: {
                padding: {
                    x: 10,
                    y: 12
                }
            }
        },

        tape: {
            text: {
                y: 54
            },
            withName: {
                x: { align: "right", dx: 11 }
            },
            x: { align: "right", dx: 11 },
            y: { align: "top", dy: -114 }
        }
    });
}

if (cleverapps.styles.StarsProgressBar) {
    cleverapps.overrideStyles(cleverapps.styles.StarsProgressBar, {
        bar: {
            offsetX: 6,
            dy: 5
        },

        barAnimation: {
            offsetX: -15
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RateWindow, {
    width: 850,
    height: 300,

    text: {
        width: 820,
        height: 250
    }
});

if (cleverapps.styles.ExtraWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ExtraWindow, {
        window: {
            padding: {
                left: 30,
                top: 60,
                right: 30,
                bottom: 80
            },
            CloseButton: {
                x: { align: "right", dx: 20 },
                y: { align: "top", dy: 20 }
            },
            HelpButton: {
                x: {
                    align: "left",
                    dx: 63
                },
                y: {
                    align: "top",
                    dy: -75
                }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.FriendRequestView, {
    width: 580,
    height: 270,

    processButton: {
        x: 70,
        height: 70
    },

    Avatar: {
        Margin: {
            x: 60
        }
    },

    Icon: {
        x: 262,
        y: -30
    },

    close: {
        x: 16,
        y: 14
    }
});

if (cleverapps.styles.TravelBookWindow) {
    cleverapps.overrideStyles(cleverapps.styles.TravelBookWindow, {
        content: {
            padding: {
                x: 60
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.WindowTitle.Types, {
    bg_window: {
        scale: [0.7, 1, 1],
        background: {
            height: 121,
            padding: {
                x: 60
            }
        },
        text: {
            y: { align: "center", dy: 2 }
        },
        position: [{
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: 8 }
        }, {
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: 14 }
        }, {
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: 14 }
        }],
        helpButton: {
            x: { align: "left", dx: 60 },
            y: { align: "center", dy: -2 },
            padding: {
                x: 30
            }
        }
    },

    nobg_window: {
        background: {
            padding: {
                x: 130
            }
        },
        text: {
            x: { align: "center" },
            y: { align: "center", dy: 13 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.NotificationView, {
    progress: {
        type: "blue"
    },

    padding: {
        x: 50,
        y: 50
    }
});

if (cleverapps.styles.ExpeditionPageView) {
    cleverapps.overrideStyles(cleverapps.styles.ExpeditionPageView, {
        height: 580,

        message: {
            text: {
                x: { align: "center", dx: 14 },

                height: 80
            },

            icon: {
                width: 70,
                height: 70
            },

            width: 260,
            height: 90
        },

        image: {
            y: { align: "center", dy: 35 }
        },

        current: {
            y: { align: "bottom", dy: 35 }
        },

        title: {
            x: { align: "center" },
            y: { align: "top", dy: -40, anchor: false },

            bg: {
                width: 380,
                height: 83,

                x: { align: "center" },
                y: { align: "top", dy: 0 }
            }
        },

        scroll: {
            y: { align: "center", dy: 15 }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.DeleteAccountWindow, {
    window: {
        padding: {
            left: 80,
            right: 80,
            top: 80,
            bottom: 70
        }
    },

    info: {
        padding: {
            x: 40,
            y: 30
        }
    }
});

if (cleverapps.styles.ComboBarView) {
    cleverapps.overrideStyles(cleverapps.styles.ComboBarView, {
        position: [{
            x: { align: "right", dx: -20 },
            y: { align: "top", dy: -124 }
        }, {
            x: { align: "right", dx: -20 },
            y: { align: "top", dy: -134 }
        }, {
            x: { align: "right", dx: -20 },
            y: { align: "top", dy: -164 }
        }],
        slot: {
            offset: {
                x: -6,
                y: -1
            },
            margin: 53
        }
    });
}

if (cleverapps.styles.ProlongationOfferView) {
    cleverapps.overrideStyles(cleverapps.styles.ProlongationOfferView, {
        label: {
            amount: {
                x: { align: "center", dx: 2 },
                y: { align: "center", dy: 2 }
            }
        },

        bonusLabel: {
            x: { align: "center", dx: 135 },
            y: { align: "center", dy: 73 }
        }
    });
}
if (cleverapps.styles.BoosterBeforeView) {
    cleverapps.overrideStyles(cleverapps.styles.BoosterBeforeView, {
        textAvailable: {
            y: { align: "bottom", dy: 3 },
            width: 145,

            bg: {
                y: { align: "bottom", dy: -15 },
                height: 60,
                rect: cleverapps.UI.Scale9Rect.TwoPixelXY
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.DialogueViewHorizontal, {
    widthPadding: 30,
    arrow: {
        y: { align: "top", dy: 27 }
    },

    text: {
        padding: {
            fromWallX: 50,
            x: 70,
            y: 50
        },
        verticalPadding: {
            fromWallX: 20,
            x: 20,
            y: 30
        }
    },

    title: {
        y: { align: "top", dy: -10 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MinimalDialogue, {
    maxWidth: 1290,

    helpButton: {
        position: [{
            x: { align: "left", dx: 200 },
            y: { align: "top", dy: -24 }
        }, {
            x: { align: "left", dx: 306 },
            y: { align: "top", dy: -39 }
        },
        {
            x: { align: "left", dx: 306 },
            y: { align: "top", dy: -39 }
        }]
    },

    person: {
        onBackground: true,
        margin: 40
    },

    background: {
        height: 306,
        verticalScale: 0.6
    },
    
    text: {
        minWidth: 500,
        padding: {
            top: 15,
            bottom: 25,
            left: 20,
            right: 50
        },

        verticalPadding: {
            top: 15,
            bottom: 20,
            left: 0,
            right: 20
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DialoguePersonTitleView, {
    text: {
        y: { align: "center", dy: 5 },
        padding: {
            x: 50,
            y: 5
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.UI.Tooltip, {
    content: {
        offset: {
            y: 4
        }
    }
});

if (cleverapps.styles.PromotionSaleWindow) {
    cleverapps.overrideStyles(cleverapps.styles.PromotionSaleWindow[Offers.TYPES.PROMOTION_SALE], {
        title: {
            x: { align: "center", dx: -2 },
            y: { align: "center", dy: 476 }
        },

        header: {
            y: { align: "top", dy: 25 }
        },

        lots: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -40 },

            marginX: 74
        }
    });
}

if (cleverapps.styles.PromotionSaleLot) {
    cleverapps.overrideStyles(cleverapps.styles.PromotionSaleLot[Offers.TYPES.PROMOTION_SALE], {
        width: 410,
        height: 572,

        reward: {
            width: 380,
            height: 440,

            margin: {
                x: 10,
                y: -20
            }
        },

        badge: {
            x: { align: "right", dx: 35 },
            y: { align: "top", dy: 85 }
        },

        button: {
            width: 250,
            height: 90,

            y: { align: "bottom", dy: 20 }
        }
    });
}

if (cleverapps.styles.PackOfferComponent && cleverapps.styles.PackOfferComponent[Offers.TYPES.STICKERS_PACK]) {
    cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent[Offers.TYPES.STICKERS_PACK], {
        pack: {
            offsetY: 420,
            offsetX: 90,
            badge: {
                x: { align: "right", dx: 30 },
                y: { align: "top", dy: 125 },
                rotation: 30
            }
        },
        tap: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -80 },
            rotation: 0,
            scaleX: 1
        }
    });
}

if (cleverapps.styles.PackOfferComponent && cleverapps.styles.PackOfferComponent[Offers.TYPES.KRAKENFEAST]) {
    cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent[Offers.TYPES.KRAKENFEAST], {
        pack: {
            title: {
                font: cleverapps.styles.FONTS.LIGHT_PACK_BUTTON_TEXT
            }
        }
    });
}

if (cleverapps.styles.QuestIcon) {
    cleverapps.overrideStyles(cleverapps.styles.QuestIcon, {
        progress: {
            height: 60
        }
    });
}

if (cleverapps.styles.QuestInfoView) {
    cleverapps.overrideStyles(cleverapps.styles.QuestInfoView, {
        regular: {
            arrow: {
                x: { align: "left", dx: -24 }
            }
        },

        compact: {
            arrow: {
                x: { align: "left", dx: -22 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RestoreProgressButton, {
    height: 104
});

if (cleverapps.styles.HintButtonBooster) {
    cleverapps.overrideStyles(cleverapps.styles.HintButtonBooster, {
        width: 150,
        height: 120,

        content: {
            margin: -25,
            direction: cleverapps.UI.VERTICAL,
            layout: {
                y: { align: "center", dy: 30 }
            }
        }
    });
}

if (cleverapps.styles.LeaguesWindow) {
    cleverapps.overrideStyles(cleverapps.styles.LeaguesWindow, {
        window: {
            decors: {
                "leaders_window_cap": true
            }
        },
        contentPadding: { x: -13, top: 330 }
    });
}

if (cleverapps.styles.TradeWindow) {
    cleverapps.overrideStyles(cleverapps.styles.TradeWindow, {
        window: {
            padding: {
                x: 60,
                top: 50,
                bottom: 55
            }
        }
    });
}

(function () {
    [
        cleverapps.styles.UI.Button.Images.button_green,
        cleverapps.styles.UI.Button.Images.button_blue,
        cleverapps.styles.UI.Button.Images.button_red,
        cleverapps.styles.UI.Button.Images.button_purple,
        cleverapps.styles.UI.Button.Images.small_button_blue,
        cleverapps.styles.UI.Button.Images.small_button_green
    ].forEach((obj) => {
        cleverapps.overrideStyles(obj, {
            SKIP_RESOLUTION: {
                padding: {
                    left: 0.3,
                    right: 0.3,
                    top: 0.05,
                    bottom: 0.2
                }
            }
        });
    });
}());

cleverapps.overrideStyles(cleverapps.styles.SettingsWindow, {
    textOpacity: 180,

    padding: {
        top: 0,
        x: 10,
        bottom: -10
    },

    user: {
        padding: {
            top: 0,
            bottom: 10
        }
    },

    avatar: {
        padding: {
            left: 20,
            right: 10,
            top: 15,
            bottom: 15
        },

        size: {
            width: 183,
            height: 193
        }
    },

    text: {
        size: [{ width: 300 }, { width: 800 }, { width: 800 }]
    },

    controlButton: {
        width: 110,
        height: 101
    },

    grid: {
        margin: {
            y: 25
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.LanguageButton, {
    fontSize: {
        default: 40,
        ar: 55
    },

    text: {
        dy: {
            default: 3
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.AboutWindow, {
    button: {
        height: 101
    }
});

if (cleverapps.styles.UnitsLibraryWindow) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsLibraryWindow, {
        withTitle: true,

        size: [{
            width: 960,
            height: 1200
        }, {
            width: 1398,
            height: 918
        }, {
            width: 1398,
            height: 918
        }],

        padding: {
            x: 34,
            y: 18
        },

        tabs: {
            position: {
                x: { align: "left", dx: 0 },
                y: { align: "bottom", dy: -112 }
            },
            direction: cleverapps.UI.HORIZONTAL,
            type: Tabs.Types.tabs_bottom,
            size: [{
                width: 168,
                height: 124
            }, {
                width: 242,
                height: 124
            }, {
                width: 242,
                height: 124
            }],
            margin: -10,
            iconMaxScale: [1.2, 1, 1],
            changeIconColor: false,
            changeIconOpacity: true,

            insideWindow: true,
            moveUpSelected: true,
            selectAnimation: "base",

            attention: {
                x: { align: "right", dx: -6 },
                y: { align: "bottom", dy: 56 }
            }
        },

        window: {
            Foreground: {
                padding: {
                    left: 0,
                    right: 0,
                    bottom: 0,
                    top: 0
                },

                contentPadding: {
                    left: 0,
                    right: 0,
                    bottom: 104,
                    top: 0
                }
            },

            decors: {
                "window_notch_bottom": false,
                "window_notch_bottom_background": true,
                "window_liana_bottom_left": false,
                "window_liana_bottom_right": false,
                "window_liana_top_left": true,
                "window_liana_top_right": true,
                "window_liana_left": true,
                "window_liana_right": true
            }
        }
    });
}

if (cleverapps.styles.HeroDetailsLayout) {
    cleverapps.overrideStyles(cleverapps.styles.HeroDetailsLayout, {
        height: 352,

        buttonInfo: {
            x: { align: "right", dx: -10 },
            y: { align: "top", dy: -10 }
        },

        grid: {
            size: [{ width: 630 }, { width: 1074 }, { width: 1074 }],

            position: {
                x: { align: "left", dx: 250 },
                y: { align: "top", dy: -47 }
            },

            scroll: {
                x: { align: "left", dx: 250 },
                y: { align: "top", dy: -47 }
            },

            margin: {
                x: 44,
                y: 20
            },

            padding: {
                x: 20,
                top: 40,
                bottom: 60
            }
        },

        foreground: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        },

        infoHeroText: {
            x: { align: "center", dx: 116 },
            y: { align: "center", dy: -28 },

            size: [{ width: 626, height: 240 }, { width: 1080, height: 240 }, { width: 1080, height: 240 }]
        },

        heroIcon: {
            position: {
                x: { align: "left", dx: 20 },
                y: { align: "top", dy: -87 }
            }
        }
    });
}

if (cleverapps.styles.UnitsTab) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsTab, {
        margin: 30,
        padding: {
            x: 0,
            top: 30,
            y: 20
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.DialogueViewVertical, {
    replica: {
        margin: -91,
        textOffsetY: -13
    },

    text: {
        width: 388,
        x: { align: "center", dx: 38 }
    },

    title: {
        parent: "person",
        width: 150,
        backGround: {
            text: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 3 }
            }
        },
        y: { align: "bottom", dy: -28 }
    }
});

if (cleverapps.styles.HeroesTab) {
    cleverapps.overrideStyles(cleverapps.styles.HeroesTab, {
        size: [{ width: 894 }, { width: 1334 }, { width: 1334 }]
    });
}

if (cleverapps.styles.FamilyLayout) {
    cleverapps.overrideStyles(cleverapps.styles.FamilyLayout, {
        title: {
            x: { align: "center" },
            y: { align: "top", dy: 0 }
        },

        grid: {
            position: {
                x: { align: "left", dx: 0 },
                y: { align: "center", dy: -40 }
            },

            padding: {
                x: 30,
                top: 54,
                bottom: 72
            },

            separator: {
                x: { align: "center" },
                y: { align: "top", dy: -70 }
            },

            iconsDecorators: {
                layout: {
                    margin: 14
                },
                stageNumber: {
                    x: { align: "right", dx: -20 },
                    y: { align: "bottom", dy: 10 }
                }
            }
        }
    });
}

if (cleverapps.styles.UnitLibraryIconBg) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIconBg, {
        width: 175,
        height: 175,

        selected: {
            width: 195,
            height: 195
        },

        title: false,

        icon: {
            x: 0,
            y: 0,
            width: 160,
            height: 160,
            maxScale: 1.3
        },

        iconUnknown: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        }
    });
}

if (cleverapps.styles.UnitLibraryIconPrize) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIconPrize, {
        prize: false,
        coin: true,
        background: true
    });
}

if (cleverapps.styles.UnitLibraryIcon) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIcon, {
        footer: false
    });
}

if (cleverapps.styles.ExtraBarIconView) {
    cleverapps.overrideStyles(cleverapps.styles.ExtraBarIconView, {
        title: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -14 },

            width: 144,
            height: 56,
            offsetY: 6,
            factorX: 0.86,
            factorY: 1.20
        }
    });
}

if (cleverapps.styles.ProfileWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ProfileWindow, {
        nameGenerator: {
            bg: {
                x: { align: "right", dx: -10 },
                y: { align: "center" },

                padding: {
                    y: 5
                }
            },
            nickname: {
                offsetY: 2,
                line: undefined
            }
        },

        avatarPicker: {
            avatarsBox: {
                margin: { x: 30, y: 10 },
                padding: { y: 40 },

                avatar: {
                    mark: {
                        x: { align: "right", dx: 5 },
                        y: { align: "bottom", dy: -5 }
                    }
                }
            },

            scroll: {
                width: 1000,
                height: 580
            }
        },

        button: {
            width: 320
        }
    });
}

(function () {
    [
        cleverapps.styles.UI.Button.Images.settings_control_button,
        cleverapps.styles.UI.Button.Images.settings_control_red_button
    ].forEach((obj) => {
        cleverapps.overrideStyles(obj, {
            SKIP_RESOLUTION: {
                padding: {
                    top: 0.05,
                    bottom: 0.12
                }
            }
        });
    });
}());

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SETTINGS_WINDOW_NAME_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SETTINGS_WINDOW_ID_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SETTINGS_WINDOW_FOLLOW_US_TEXT: {
        name: "nostroke",
        size: 58,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SETTINGS_WINDOW_VERSION_TEXT: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    WEEKLY_GOALS_DAY_TEXT: {
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        size: 35
    },

    WEEKLY_GOALS_DAY_CLOSED_TEXT: {
        size: 35,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    WEEKLY_GOALS_POINTS_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_BROWN_COLOR_2,
        stroke: undefined
    },

    WEEKLY_GOALS_BAR_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_BROWN_COLOR_1
    },
    WEEKLY_GOALS_REWARD_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_BROWN_COLOR_1
    },

    WEEKLY_GOALS_TIMER_TEXT: {
        name: "nostroke",
        size: 40,
        stroke: undefined,
        shadow: undefined,
        color: cleverapps.styles.COLORS.LIGHT_BROWN_COLOR_1
    }
});

cleverapps.overrideStyles(cleverapps.styles.UI.ImageFont, {
    SKIP_RESOLUTION: {
        DESCENTS: {
            "fonts/roundedmplus-black": 0.02,
            "fonts/roundedmplus-nostroke": 0.02
        }
    },
    lettersOffset: {
        "fonts/roundedmplus-nostroke": -1
    }
});